import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { theme } from "../../styles/themes/mainTheme";

interface LocalStatusDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onToggleLocalStatus: () => void;
  isLocalLocked: boolean;
}

const LocalStatusDialog = ({
  isOpen,
  onClose,
  onToggleLocalStatus,
  isLocalLocked,
}: LocalStatusDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
    >
      <DialogTitle>
        {isLocalLocked ? t("table.local.activateLocal") : t("table.local.deactivateLocal")}
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          {isLocalLocked ? t("table.local.activateLocalConfirmationText") : t("table.local.deactivateLocalConfirmationText")}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onClose}
          sx={{
            color: theme.palette.text.secondary,
          }}
        >
          {t("header.cancel")}
        </Button>
        <Button onClick={onToggleLocalStatus} autoFocus>
          {t("header.continue")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LocalStatusDialog;
